import { type DealerWithPermissionsFragmentFragment } from '../../../../api/fragments/DealerWithPermissionsFragment';
import { type ModuleInDealerSpecsFragment } from '../../../../api/fragments/ModuleInDealerSpecs';
import DealerAssignmentForm from './DealerAssignmentForm';

export type ModuleTabsProps = {
    dealer: DealerWithPermissionsFragmentFragment;
    moduleId: string;
    module: ModuleInDealerSpecsFragment;
};

const DealerModuleManagement = ({ dealer, moduleId, module }: ModuleTabsProps) => (
    <DealerAssignmentForm key={moduleId} dealer={dealer} module={module} />
);

export default DealerModuleManagement;
